import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CotecnaUserService } from "@cotecna/session";
import { ExternalRedirectionService } from "src/app/shared/external-redirection-service/external-redirection.service";
import { environment } from "src/environments/environment";
import { LoginSource, User } from "../../models/user";
import { IdleTimeService } from "../idle-time/idle-time.service";
import { SessionService } from "../session.service";
import { StorageService } from "../storage.service";
import {
  INSPECTION_ORIGINS_KEY,
  SORT_DIRECTION_KEY,
  SORT_ORDER_KEY,
  USER_KEY,
} from "src/app/inspection/constants/constants";

@Injectable({
  providedIn: "root",
})
export class LogoutService {
  constructor(
    private userService: CotecnaUserService,
    private sessionService: SessionService,
    private storageService: StorageService,
    private router: Router,
    private idleTimeService: IdleTimeService,
    private externalRedirectionService: ExternalRedirectionService,
  ) {}

  async logout(): Promise<void> {
    const user = <User>this.userService.getUser();

    if (user) {
      switch (user.loginSource) {
        case LoginSource.external:
          await this.sessionService.externalLogout();
          this.router.navigate(["/", "session", "login"]);
          break;
        case LoginSource.internal:
          this.redirectToLogout();
          break;
      }
      this.userService.setUser(null);
      await this.storageService.remove(USER_KEY);
      await this.storageService.remove(SORT_ORDER_KEY);
      await this.storageService.remove(SORT_DIRECTION_KEY);
      await this.storageService.remove(INSPECTION_ORIGINS_KEY);
    }
  }

  private redirectToLogout(): void {
    this.externalRedirectionService.redirect(
      `${environment.webApiUrl}/login/logout`,
    );
  }

  logoutOnIdleTime() {
    this.idleTimeService.maxIdleTimeExpired.subscribe(() => this.logout());
  }
}
